import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Trail from "../../components/Trail/Trail";
import CompanyInfo from "../../components/Company Info/CompanyInfo";
import ContactUs from "../../components/Contact Us/ContactUs";
export default function Contact() {
  return (
    <>
      <Navbar />
      <ContactUs />
      <CompanyInfo />
      <Trail />
      <Footer />
    </>
  );
}
